import React, {Component} from 'react';
import {Link, hashHistory} from 'react-router';
import {connect} from 'react-redux';
import {updateModal} from '../../actions/modal.js';
import {getUserData} from '../../actions/ts_userData_actions.js';
import {Button, Modal, Grid,Row,Col,Clearfix} from 'react-bootstrap';
import {loginUser} from '../../actions/firebase_actions.js';
import Menu from '../menu/';
import Login_Register from '../login_register/';
import Playbook from '../playbook/';
import {TS_EMAIL,TS_PASS} from '../../actions/types';
import Icon from '../../images/trickstrat/ts_icon.png';
import PlaybookIcon from '../../images/trickstrat/myplaybook.png';
var loginButtons={
  borderRadius: '0%',
  marginTop:'25',
  width: '100%',
  color:'lightblue',
  letterSpacing:'2',
  fontSize:'1.2em',
  fontWeight:'100',
  background: 'transparent',
  border: '0px solid white',
  cursor:'pointer',
}
var divider={
  borderRadius: '0%',
  marginTop:'25',
  width: '50%%',
  color:'white',
  letterSpacing:'2',
  fontSize:'1.2em',
  fontWeight:'100',
  background: 'transparent',
  border: '0px solid white',
  cursor:'pointer',
}
var App = React.createClass({
  getInitialState: function() {
    var session_email = window.localStorage.getItem(TS_EMAIL);
    var session_pass = window.localStorage.getItem(TS_PASS);
    if(session_email != null && session_pass != null)
    {
    this.loginStorageUser(session_email,session_pass);
    }
    else {
    this.renderModal('login_register');
    }
              return {
                  display:'login',
              }
      },
selectGameMenu(){
  var {dispatch} = this.props;
  dispatch(updateModal(true,<Menu/>));
},

loginStorageUser(email,password) {
    var {dispatch,currentUser} = this.props;
    dispatch(loginUser({email, password})).then((data) => {
    if (data.payload.errorCode) {
      this.setState({message: data.payload.errorMessage});
    } else {
      var {dispatch, currentUser} = this.props;
      dispatch(getUserData(currentUser.uid));
      dispatch(updateModal(false,null));
      hashHistory.replace('/home');
      //browserHistory.push('/home');
    }
  });
},

showModal(content) {
  var {dispatch} = this.props;
  dispatch(updateModal(true,content));
},

renderModal(content) {
  var modalContent;
  if (content == 'menu') {
     modalContent =<Menu/>;
  }
  if (content == 'login_register') {
     modalContent =<Login_Register/>;
  }
  if (content == 'playbook') {
     modalContent =<Playbook/>;
  }
  this.showModal(modalContent);
},

selectButtonGroup(currentUser,map,content){
  var {userData} = this.props;
  var img =  <span><img width="75" height="78" src={Icon}></img></span>
var imgPlaybook =  <span><img height="150" src={PlaybookIcon}></img></span>
  if (currentUser && currentUser.uid && currentUser.emailVerified && map == "WELCOME") {
    return (
      <div>
        <label style={loginButtons}  onClick={(event) => {this.renderModal('menu');}}><span className="titleText">{img} Select a game.</span></label>

        <label style={loginButtons}  onClick={(event) => {this.renderModal('playbook');}}><span className="titleText">{imgPlaybook}</span></label>
      </div>
        )

      {/*
  <Playbook/>
  <div style={divider}>
        <Menu/>
      </div>*/}

  } else if(currentUser && currentUser.uid && currentUser.emailVerified)
  {
    return (
      <div >

      </div>)
  }
  else{

    return (
      <div >
      <label style={loginButtons} onClick={(event) => {this.renderModal('login_register');}}><span className="titleText">{img} Login to select a map.</span></label>
  {/*<Login_Register/>*/}
      </div>)
    }
},
    render() {
      var {map, overlay,currentUser} = this.props;
      var content = this.state.display;
      return (
        <div>
              {this.selectButtonGroup(currentUser,map.map, content)}
        </div>
      );
    }
  });

  module.exports = connect((state) => {
    return {currentUser: state.currentUser, map: state.map, overlay: state.overlay, modal: state.modal, userData: state.userData}
  })(App);



// WEBPACK FOOTER //
// ./src/app/components/homeButtons/index.jsx